import { getDiscountString } from '@src/shared/utils/get-discount-string/get-discount-string.util';
import { getDiscountTitle } from '@src/shared/utils/get-discount-title/get-discount-title.util';
import { ICoupon, ICouponResponse } from '../item-generated-api';

export interface ICouponDto extends Omit<ICoupon, 'discount_amount' | 'discount_percentage'> {
    status: string;
    discount_amount: number;
    discount_percentage: number;
    title: string;
    label: string;
}

export const createCouponDto = (item: ICouponResponse): ICouponDto => {
    return {
        ...item.coupon,
        id: item.coupon?.id || '',
        status: item.coupon?.status || '',
        discount_amount: item.coupon?.discount_amount ? +item.coupon?.discount_amount : 0,
        discount_percentage: item.coupon?.discount_percentage ? +item.coupon?.discount_percentage : 0,
        label: getDiscountString(item.coupon),
        title: getDiscountTitle(item.coupon),
    };
};
